import { useState } from "react";
import { FE_URL } from "../common/constants";
import axiosWithAuth from "../utils/axiosWithAuth";
import moment from "moment";
import { message } from "antd";
import getBackendErrorMessage from "../utils/getBackendErrorMessage";

export const isRestaurantOrder = (cartItems) =>
  ["restaurant_product", "restaurant_dish"].includes(cartItems?.[0]?.itemType);

export const buildOrderData = ({
  user,
  cartItems,
  userInfo,
  subTotal,
  amountTotal,
  deliveryPrice,
  deliveryType,
  taxBreakdown,
  tip = 0,
}) => {
  let orderData = {
    order: {
      user_id: user.id,
      business_id: cartItems[0].businessID,
      status: "Completed",
      subtotal: subTotal,
      total: amountTotal,
    },
    orderItems: cartItems.map((item) => {
      return {
        type: item.itemType,
        item_id: item.itemID,
        quantity: item.itemQuantity,
      };
    }),
    user: {
      fname: user.fname,
      lname: user.lname,
      email: user.email,
    },
  };

  if (cartItems[0].itemType === "event_ticket") {
    orderData = {
      ...orderData,
      attendee: {
        user_id: user.id,
        event_id: cartItems[0].sourceID,
        ticket_id: cartItems[0].itemID,
        quantity: 1,
        price: cartItems[0].itemPrice,
      },
    };
  }

  if (cartItems[0].itemType === "service_product") {
    orderData = {
      ...orderData,
      appointment: {
        buyer_id: user.id,
        product_id: cartItems[0].itemID,
        status: "confirmed",
        start_time: cartItems[0].startTime,
        business_id: cartItems[0].businessID,
      },
    };
  }

  if (isRestaurantOrder(cartItems)) {
    const restaurantDeliveryType =
      deliveryType || (deliveryPrice > 0 ? "Delivery" : "Pickup");

    orderData = {
      businesses_id: cartItems[0].businessID,
      date_order: moment(),
      total_price_order: amountTotal,
      delivery_type: restaurantDeliveryType,
      delivery_address:
        restaurantDeliveryType === "Delivery" && userInfo
          ? userInfo.address
          : null,
      userInfo: userInfo ? userInfo : null,
      deliveryPrice: deliveryPrice ? deliveryPrice : 0,
      tip,
      details: cartItems.map((item) => ({
        dish_id: item.itemID,
        dish_quantity: item.itemQuantity,
        dish_price: item.itemPrice,
        total_price: item.itemTotal,
        extras: item.extras,
      })),
    };
  }

  if (taxBreakdown) {
    const order = isRestaurantOrder(cartItems) ? orderData : orderData.order;
    order.tax_breakdown = taxBreakdown;
  }

  return orderData;
};

export const useCreateOrder = (
  user,
  cartItems,
  userInfo,
  subTotal,
  amountTotal,
  deliveryPrice,
  deliveryType,
) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const createOrder = async () => {
    setIsSubmitting(true);

    let APIURL = "/api/orders/create";

    const payload = buildOrderData({
      user,
      cartItems,
      userInfo,
      subTotal,
      amountTotal,
      deliveryPrice,
      deliveryType,
    });

    if (isRestaurantOrder(cartItems)) {
      APIURL = "/api/restaurant/order/createOrderRestaurant";
    }

    console.log("[Bizzll] Order payload to send:", payload);

    try {
      const res = await axiosWithAuth().post(APIURL, payload);

      if (isRestaurantOrder(cartItems)) {
        window.location.replace(
          `${FE_URL}/order-confirmation-restaurant/${res.data.orderID}`,
        );
      } else {
        window.location.replace(
          `${FE_URL}/order-confirmation/${res.data.orderID}`,
        );
      }

      return res;
    } catch (error) {
      message.error(getBackendErrorMessage(error));
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  // Return all necessary functions/states
  return [createOrder, isSubmitting];
};
